import { LOGO_URL } from 'app/constants';
import { CheckoutServiceModule } from 'components/checkout/checkout.service';

import { PlanDetailsModule } from '../planDetails/planDetails';
import template from './selectPlan.html';
import './selectPlan.scss';

export const SelectPlanModule = angular
    .module('app.components.changePlan.selectPlan', [
        CheckoutServiceModule,
        PlanDetailsModule
    ]).component('selectPlan', {
        template,
        bindings: {
            plans: '<',
            planSortExpression: '<',
            user: '<',
            onPlanSelected: '&',
            isTrial: '<',
            note: '<',
            hideGreeting: '<',
            showBorderOnPlans: '<',
            showAlternate: '<'
        },
        controller: class SelectPlanCtrl {
            constructor(checkoutService) {
                this.LOGO_URL = LOGO_URL;
                this.checkoutService = checkoutService;
            }

            $onInit() {
                this.checkoutService.logProductImpression(this.plans);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/changePlan/selectPlan/selectPlan.js